import { pushStorefrontDataToDatalayer } from '../../analytics/storefront'
import { StoreFrontState } from '../models/StoreFrontState'
import {
  FETCH_STOREFRONT_PENDING,
  FETCH_STOREFRONT_DONE,
  FETCH_STOREFRONT_ERROR,
  StoreFrontActionTypes,
  FETCH_STOREFRONT_STORE_ID,
  SET_REDIRECT_URL,
  SET_DEALER_PAYMENT_DATA,
} from './actions/storefront.actions'

export function pending(): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_PENDING,
    payload: {},
  }
}

export function initial(data): StoreFrontActionTypes {
  pushStorefrontDataToDatalayer(data)
  return done(data)
}

export function done(data): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_DONE,
    payload: {
      data,
    },
  }
}

export function error(err): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_ERROR,
    payload: {
      err,
    },
  }
}

export function storeId(id): StoreFrontActionTypes {
  return {
    type: FETCH_STOREFRONT_STORE_ID,
    payload: {
      id,
    },
  }
}

export function getStorefrontData(store) {
  return store.storefront.data
}

export function getStoreFrontId(store) {
  return store.storefront.id
}

export function setRedirectUrl(data): StoreFrontActionTypes {
  return {
    type: SET_REDIRECT_URL,
    payload: data,
  }
}

export function getRedirectUrl(store) {
  return store.storefront.redirectUrl
}

export function setDealerPaymentData(data): StoreFrontActionTypes {
  return {
    type: SET_DEALER_PAYMENT_DATA,
    payload: data,
  }
}

const initialState: StoreFrontState = {
  id: '',
  pending: false,
  data: {},
  error: null,
  redirectUrl: '',
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_STOREFRONT_PENDING:
      return {
        ...state,
        data: {},
        pending: true,
        error: null,
      }

    case FETCH_STOREFRONT_DONE:
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        error: null,
      }
    case FETCH_STOREFRONT_ERROR:
      return {
        ...state,
        data: {},
        pending: false,
        error: true,
      }
    case FETCH_STOREFRONT_STORE_ID:
      return {
        ...state,
        id: action.payload.id,
      }
    case SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload,
      }

    case SET_DEALER_PAYMENT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          dealerData: {
            ...state.data.dealerData,
            paymentData: {
              ...state.data?.dealerData?.paymentData,
              iban: action?.payload?.iban,
              bic: action?.payload?.bic,
            },
          },
        },
      }

    default:
      return state
  }
}
